import { render, staticRenderFns } from "./Buffers.vue?vue&type=template&id=1205655f&"
import script from "./Buffers.vue?vue&type=script&lang=js&"
export * from "./Buffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports